import AuthService from '@/api/auth';
import authApi from '@/api/axios-api';
import { resetUnauthenticatedFlag } from '@/api/axios-api';

const SSO_CALLBACK = 'auth/callback';

export const auth = {
    namespaced: true,
    state: {
        loggedIn: false,
        user: null,
        token: null,
        ttl: null,
        timer: null,
        permissions: null,
        products: [],
        email: null,
        company: null,
    },
    getters: {
        companyLogo() {
            return require('@/assets/images/prohealth.png');
        },
        isLoggedIn(state) {
            return state.loggedIn;
        },
        getFullName(state) {
            return state.user ? state.user.name + ' ' + state.user.surname : '';
        },
        isGodUser(state) {
            return state.user?.is_god ? true : false;
        },
        userCompanyId(state) {
            return state.user ? (state.user?.is_god ? state.user.company_id : { id: state.user.company_id }) : null;
        },
        getUserPermissions(state) {
            return state.permissions;
        },
        loggedUser(state) {
            return state.user;
        },
        getProducts(state) {
            return state.products;
        },
        isCstOnly(state) {
            /**
             * No PHA product enabled
             * @type {boolean}
             */
            let isCstOnly = true

            if (Array.isArray(state.products)) {
                state.products.forEach((product) => {
                    if (product.code === 'PHA') {
                        isCstOnly = false;
                    }
                });
            }

            return isCstOnly
        }
    },
    actions: {
        login({ commit }, user) {
            return AuthService.login(user, commit).then(
                (user) => {
                    return Promise.resolve(user);
                },
                (error) => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },

        resetPassword({ commit }, user) {
            return AuthService.resetPassword(user, commit).then(
                (user) => {
                    return Promise.resolve(user);
                },
                (error) => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },

        logout({ commit }) {
            commit('logout');
        },

        verifyOtp({ commit }, user) {
            return AuthService.verifyOtp(user, commit).then(
                (user) => {
                    return Promise.resolve(user);
                },
                (error) => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },


        refreshToken({ commit }) {
            return AuthService.refreshToken(commit).then(
                (token) => {
                    // restart timer for refresh token
                    commit('setTokenRefreshTimer');
                    return Promise.resolve(token);
                },
                (error) => {
                    commit('setRefreshTokenFailure');
                    return Promise.reject(error);
                }
            );
        },
        passwordResetRequest({ commit }) {
            return AuthService.resetPasswordRequest().then(
                (data) => {
                    if (data.statusCode === 200) {
                        commit('logout');
                    }
                    return Promise.resolve(data);
                },
                (error) => {
                    return Promise.reject(error);
                }
            );
        },

        async callbackSSO({ commit }, { authCode, state, session_state }) {
            try {
                const params = new URLSearchParams({
                    code: authCode,
                    state,
                });
                if (session_state) {
                    params.append('session_state', session_state);
                }

                const response = await authApi.get(`${SSO_CALLBACK}?${params.toString()}`);
                const payload = response.data;

                if (response.status === 200 && payload?.status === 'OK' && payload?.data?.token) {
                    resetUnauthenticatedFlag();
                    commit('loginSuccess', payload.data);
                    commit('setTokenRefreshTimer');
                    return { success: true };
                }

                // Backend logs the real reason; client gets generic failure only
                return { success: false };
            } catch (error) {
                return { success: false };
            }
        },
    },

    mutations: {
        loginSuccess(state, user) {

            state.products = user.productList

            state.loggedIn = true;
            state.user = user.user;
            if (!user.user.company_id) {
                state.user.is_god = true;
            }
            state.token = user.token;
            state.ttl = user.ttl;
            state.permissions = user.permissionList;
            // get company info if available
            state.company = user.company || null;
        },
        loginFailure(state) {
            state.loggedIn = false;
            state.user = null;
            state.token = null;
            state.ttl = null;
            state.permissions = null;
        },
        logout(state) {
            state.loggedIn = false;
            state.user = null;
            state.token = null;
            state.ttl = null;
            state.permissions = null;
            state.company = null;

            // // remove the event listeners
            // document.removeEventListener('mousemove', this.updateLastActive);
            // document.removeEventListener('keydown', this.updateLastActive);
            // document.removeEventListener('click', this.updateLastActive);
        },
        setTokenRefreshTimer(state) {
            // console.log('Start ', new Date())
            // console.log('setTokenRefreshTimer() ', state.ttl)
            state.timer = setTimeout(() => {
                // console.log('setTokenRefreshTimer / setTimeout', state.ttl)
                // console.log('Now ', new Date())
                // refresh the token with updated token
                this.dispatch('auth/refreshToken');
            }, ((state.ttl * 60) - 60) * 1000); //multiply 1000  (milliseconds)
        },
        setRefreshToken(state, token) {
            state.token = token;
        },
        setRefreshTokenFailure(state) {
            state.loggedIn = false;
            state.user = null;
            state.token = null;
            state.timer = null;
            state.permissions = null;
        },
        setCompanyId(state, val) {
            if (val) state.user.company_id = val;
        },
    },
};
